import React, { useMemo } from 'react'
import T from 'prop-types'
import { Box, Divider, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FavoriteIcon from '@mui/icons-material/Favorite'

import ChoiceRecap from 'components/atoms/ChoiceRecap'

import {
  FILTER_CARS_BOOKED_TYPE_ASSIGNED_CHOICE,
  FILTER_CARS_BOOKED_TYPE_FIRST_CHOICE,
  FILTER_CARS_BOOKED_TYPE_NONE_CHOICE,
  FILTER_CARS_BOOKED_TYPE_NOT_ASSIGNED_CHOICE,
  FILTER_CARS_BOOKED_TYPE_SECOND_CHOICE,
} from 'hooks/useCarsFilters'

import { getCarsBookedRecapValues } from './carsBookedLib'

export default function CarsBookedChoicesRecap({
  cars = [],
  filters,
  setFilteringRecapValues,
  onlyFavorites = false,
  onToggleFavorites,
}) {
  const { t } = useTranslation()

  const numberFormatter = new Intl.NumberFormat('it-IT')

  const choices = useMemo(() => getCarsBookedRecapValues(cars), [cars])

  return (
    <>
      <Stack
        direction="row"
        flexWrap="wrap"
        data-testid="cars-booked-choices-recap"
      >
        <ChoiceRecap
          id="total"
          title={t('carsBooked.labelTitle.allCars')}
          value={choices.total}
          handleClick={() =>
            setFilteringRecapValues(FILTER_CARS_BOOKED_TYPE_NONE_CHOICE)
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_CARS_BOOKED_TYPE_ASSIGNED_CHOICE}
          title={t('carsBooked.labelTitle.assigned')}
          value={choices.assigned || '-'}
          handleClick={() =>
            setFilteringRecapValues(FILTER_CARS_BOOKED_TYPE_ASSIGNED_CHOICE)
          }
          selected={
            filters.carsBookedType === FILTER_CARS_BOOKED_TYPE_ASSIGNED_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_CARS_BOOKED_TYPE_NOT_ASSIGNED_CHOICE}
          title={t('carsBooked.labelTitle.notAssigned')}
          value={choices.notAssigned || '-'}
          handleClick={() =>
            setFilteringRecapValues(FILTER_CARS_BOOKED_TYPE_NOT_ASSIGNED_CHOICE)
          }
          selected={
            filters.carsBookedType ===
            FILTER_CARS_BOOKED_TYPE_NOT_ASSIGNED_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_CARS_BOOKED_TYPE_FIRST_CHOICE}
          title={t('carsBooked.labelTitle.firstChoice')}
          value={choices.firstChoice || '-'}
          handleClick={() =>
            setFilteringRecapValues(FILTER_CARS_BOOKED_TYPE_FIRST_CHOICE)
          }
          selected={
            filters.carsBookedType === FILTER_CARS_BOOKED_TYPE_FIRST_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_CARS_BOOKED_TYPE_SECOND_CHOICE}
          title={t('carsBooked.labelTitle.secondChoice')}
          value={choices.secondChoice || '-'}
          handleClick={() =>
            setFilteringRecapValues(FILTER_CARS_BOOKED_TYPE_SECOND_CHOICE)
          }
          selected={
            filters.carsBookedType === FILTER_CARS_BOOKED_TYPE_SECOND_CHOICE
          }
          border
        />
        {onToggleFavorites && (
          <>
            <Box pr={1} />
            <ChoiceRecap
              id="favorites"
              title={
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <FavoriteIcon
                    sx={{
                      fontSize: 14,
                      color: onlyFavorites ? 'error.main' : 'inherit',
                    }}
                  />
                  <span>{t('carsToBuy.labelTitle.favorites')}</span>
                </Stack>
              }
              value={`${choices.favorites || 0}`}
              handleClick={onToggleFavorites}
              selected={onlyFavorites}
              border
            />
          </>
        )}
        <Box pr={2} />
        <Divider orientation="vertical" variant="middle" flexItem />
        <ChoiceRecap
          title={t('carsToBuy.labelTitle.totalValueSelected')}
          value={
            choices.totalValue
              ? `€ ${numberFormatter.format(choices.totalValue)}`
              : '-'
          }
        />
      </Stack>
    </>
  )
}

CarsBookedChoicesRecap.propTypes = {
  cars: T.array,
  filters: T.object,
  setFilteringRecapValues: T.func,
  onlyFavorites: T.bool,
  onToggleFavorites: T.func,
}
